import React from 'react';
import { Highlight } from 'react-instantsearch';
import PropTypes from 'prop-types';

import hexagon from '../../../../../../../public/media/images/icons/hexagon-yellow.png'; /* eslint-disable-line */
import { trackClick } from '../../../../helpers/tracking-helper';

const CustomHit = ({ hit, onClick }) => (
    <div className="grid__cell" key={hit.objectID}>
        <a
            href={hit.uri}
            data-elementid={hit.objectID}
            className={hit.vendorContent ? 'vendor-des insightsCard' : 'insightsCard'}
            onClick={() => {
                trackClick(hit.objectID, hit.uri, true);
                onClick();
            }}
        >
            <div className="insightsCard__asset insightsCard__asset__container">
                <img
                    data-src={hit.image}
                    alt={hit.title}
                    className="insightsCard__image lazyloaded"
                    src={hit.image}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
            </div>
            <div
                className="insightsCard__vendor"
                style={{
                    backgroundColor: hit.vendorContent ? '#05264a' : '#fab94d',
                }}
            >
                {hit.vendorContent && (
                    <>
                        <img src={hexagon} className="insightsCard__vendor__img" />
                        <p className="insightsCard__vendor__text">Sponsored</p>
                    </>
                )}
            </div>
            <span className="meta -date">{hit.formattedPostDate}</span>
            <h4 className="insightsCard__title">
                <Highlight hit={hit} attribute="title" />
            </h4>
            {hit.categories.map((category, index) => (
                <span className="meta insightsCard__meta" key={index}>
                    {category.singular}
                </span>
            ))}
        </a>
    </div>
);

CustomHit.propTypes = {
    hit: PropTypes.object,
    onClick: PropTypes.func,
};

export default CustomHit;
